"use strict";
import keys from "lodash/keys";
import find from "lodash/find";
import isObject from "lodash/isObject";
import isArray from "lodash/isArray";
import each from "lodash/forEach";
export default {
    parse: function parse(data) {
        var _keys = keys(data);
        var storeKey = find(_keys, function(k) {
            return k.indexOf("ById") === -1 && k !== "count";
        });
        var _store = data[storeKey];
        var lookupFn = function(attr) {
            if (isObject(attr) || isArray(attr)) {
                if (isArray(attr) || !attr.$type) {
                    each(attr, function(record, n) {
                        attr[n] = lookupFn(record);
                    });
                    return attr;
                } else if (attr.$type === "ref") {
                    var _obj = data[attr.value[0]][attr.value[1]];
                    if (isObject(_obj) && !_obj.id) {
                        _obj.id = attr.value[1];
                    }
                    return _obj;
                } else {
                    throw new TypeError("".concat(attr.$type, " in ").concat(storeKey));
                }
            } else {
                return attr;
            }
        };
        return lookupFn(_store);
    }
};
